module.exports = __webpack_public_path__ + "static/media/ghm.7ee8339f.png";